import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class EventDetailsModalProxy {
    readonly isOpen = signal(false);
}
